<template>
  <v-navigation-drawer
    class="bibleGreen"
    v-model="drawer"
    absolute
    left
    temporary
    width="300"
  >
    <v-list dense active-class="white--text text--accent-4">
      <v-list-item
        class="d-flex align-center cursor"
        active-class="SelectedTile-active"
        v-for="item in menuOptions"
        :key="item.path"
        :to="item.path"
        @click="navigate(item.path)"
        style="height: 80px"
      >
        <div class="lightGold pa-2 rounded-circle">
          <v-icon medium color="white"> {{ item.icon }} </v-icon>
        </div>
        <v-list-item-title
          class="py-3 mr-3 text-h6 font-weight-medium white--text"
          >{{ item.text }}</v-list-item-title
        >
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: "Drawer",
  props: { drawerIsOpen: { type: Boolean } },
  methods: {
    navigate() {
      this.drawer = false
    },
  },
  data: function () {
    return {
      menuOptions: [
        { icon: "mdi-map-marker-radius", text: "ראשי", path: "/" },
        {
          icon: "mdi-history",
          text: this.$t("history.title"),
          path: "/history",
        },
        {
          icon: "mdi-binoculars",
          text: "אודות האפליקציה",
          path: "/about/app",
        },
        {
          icon: "mdi-book-open-page-variant-outline",
          text: "אודות הישיבה",
          path: "/about/yeshiva",
        },
        { icon: "mdi-message ", text: "צור קשר/תרום ידע", path: "/contact" },
      ],
    }
  },
  computed: {
    drawer: {
      get() {
        return this.drawerIsOpen
      },
      set(v) {
        this.$emit("toggleMenu", v)
      },
    },
  },
}
</script>
